module.exports = __webpack_public_path__ + "img/orange_080.963c6026.png";